import { useExperimentalModeStore } from '../store/experimental-mode-store';
import { useFeatureFlagStore } from '../store/feature-flag-store';
import { FeatureAccess } from './useFeatureAccessControls';

export const useExperimentalMode = () => {
  const { 
    experimentalModeEnabled, 
    setExperimentalModeEnabled, 
    toggleExperimentalMode 
  } = useExperimentalModeStore();
  
  const { hasFeatureAccess } = useFeatureFlagStore();

  return {
    experimentalModeEnabled,
    setExperimentalModeEnabled,
    toggleExperimentalMode,
    hasFeatureAccess: hasFeatureAccess(FeatureAccess.EXPERIMENTAL_MODE),
  };
};